import React, { useEffect,  useState } from "react";

import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row, Offcanvas, Button } from "react-bootstrap";
import PayRollFilterBox from "../../../components/FilterBox/PayRollFilter/PayRollFilter";
import { FiMenu } from "react-icons/fi";
import PayRollTable from "../../../components/Tables/PayRollTable";
import {
  DeptList,
  SalaryDeductSumm,
  SalaryDeductSummFun,
} from "../../../Redux/Slice/PayRoll/PayRollSlice";
import { Loader } from "../../../components/Loader/Loader";
import { useTheme } from "../../../Themecontext/Themecontext";

export const SalarySummary = () => {
  const dispatch = useDispatch();
  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { SalaryDeductSummdata } = useSelector((state) => state.PayRollSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWPAYROLL");

  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWPAYROLLDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;

  const Firm = Cookies.get("Firm");
  let FinacialYear = Cookies.get("FinancialYear");

  // ✅ FILTER STATES

  const [filters, setFilters] = useState({
    year: [],
    month: [],
  });
  const [search, setSearch] = useState({
    year: "",
    month: "",
  });

  const [showFilter, setShowFilter] = useState(false);

  useEffect(() => {
    dispatch(SalaryDeductSummFun());
    dispatch(
      DeptList({
        Firm: Firm,
        Year: FinacialYear,
      }),
    );
    dispatch(
      SalaryDeductSumm({
        Firm: Firm,
        Year: FinacialYear,
      }),
    );
  }, [dispatch, Firm, FinacialYear]);

  const toggleItem = (type, item) => {
    setFilters((prev) => {
      const selected = prev[type];

      return {
        ...prev,
        [type]: selected.includes(item.value)
          ? selected.filter((i) => i !== item.value)
          : [...selected, item.value],
      };
    });
  };
  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);

    setFilters((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };
  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const monthOptions = [
    { id: 4, month: "April" },
    { id: 5, month: "May" },
    { id: 6, month: "June" },
    { id: 7, month: "July" },
    { id: 8, month: "August" },
    { id: 9, month: "September" },
    { id: 10, month: "October" },
    { id: 11, month: "November" },
    { id: 12, month: "December" },
    { id: 1, month: "January" },
    { id: 2, month: "February" },
    { id: 3, month: "March" },
  ];

  const yearList =
    DataMain?.AC_Year_List?.map((item) => ({
      label: item?.AcYear,
      value: item?.AcYearID,
    })) || [];

  const monthList =
    monthOptions?.map((item) => ({
      label: item?.month,
      value: item?.id,
    })) || [];

  const applyFilters = () => {
    dispatch(SalaryDeductSummFun());
    let finalYearIDs = [];

    if (filters.year.length === 0) {
      finalYearIDs = [Cookies.get("FinancialYear")];
    } else {
      finalYearIDs = filters.year;
    }

    dispatch(
      SalaryDeductSumm({
        Firm: Firm,
        Year: finalYearIDs.join(","),
        MonthIDs: filters.month.join(","),
      }),
    );
  };
  // ✅ MORE TABLE DATA

  const getRows = SalaryDeductSummdata?.DedSumm?.map((label, index) => ({
    srNumber: index + 1,
    MonthName: label.MonthName,
    Grosssalry: label.Grosssalry,
    PTamt: label.PTamt,
    ESIamt: label.ESIamt,
    PFamt: label.PFamt,
    Wefamt: label.Wefamt,
    //     Advance: label.Advance,
    NetSalary: label.NetSalary,
    OtherEarning: label.OtherEarning,
    OtherDeduction: label.OtherDeduction,
    TotDeduction: label.TotDeduction,
    TotEarning: label.TotEarning,
  }));

  const getColumns = [
    { key: "srNumber", label: "Sr. No.", align: "center" },
    {
      key: "MonthName",
      label: "Month",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { key: "NetSalary", label: "Net Salary", align: "right", format: "true" },
    {
      key: "Grosssalry",
      label: "Gross Salary",
      align: "right",
      format: "true",
    },
    { key: "PTamt", label: "PT Amount", align: "right", format: "true" },
    { key: "ESIamt", label: "ESI Amount", align: "right", format: "true" },
    { key: "PFamt", label: "PF Amount", align: "right", format: "true" },
    { key: "Wefamt", label: "WEF Amount", align: "right", format: "true" },
    // { key : "Advance", label : "Advance Amount" },
    {
      key: "OtherEarning",
      label: "Other Earning",
      align: "right",
      format: "true",
    },
    {
      key: "OtherDeduction",
      label: "Other Deduction",
      align: "right",
      format: "true",
    },
    {
      key: "TotEarning",
      label: "Total Earning",
      align: "right",
      format: "true",
    },
    {
      key: "TotDeduction",
      label: "Total Deduction",
      align: "right",
      format: "true",
    },
  ];
  if (SalaryDeductSummdata === null || SalaryDeductSummdata === "no") {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Loader />
      </div>
    );
  }

  return (
    <div
      style={{
        padding: "16px",
        background:
          isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
        minHeight: "100vh",
      }}
    >
      {/* ✅ MOBILE FILTER BUTTON */}
      <div className="d-lg-none d-flex justify-content-end mb-3">
        <Button
          onClick={() => setShowFilter(true)}
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour12,
            border: "none",
            borderRadius: "10px",
            padding: "8px 12px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
          }}
        >
          <FiMenu size={22} />
        </Button>
      </div>

      {/* ✅ OFFCANVAS */}
      <Offcanvas
        show={showFilter}
        onHide={() => setShowFilter(false)}
        style={{
          background:
            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
        }}
      >
        <Offcanvas.Header
          closeButton
          closeVariant={isdark === "dark" ? "white" : undefined}
        >
          <Offcanvas.Title
            style={{
              color:
                isdark === "light"
                  ? iscolour?.Colour12
                  : iscolourDark?.Colour12,
            }}
          >
            Filters
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <PayRollFilterBox
              title="Year"
              items={yearList}
              search={search.year}
              setSearch={(val) => handleSearch("year", val)}
              selectedItems={filters.year}
              toggleItem={(item) => toggleItem("year", item)}
              selectAll={() => selectAll("year", yearList)}
            />

            <PayRollFilterBox
              title="Month"
              items={monthList}
              search={search.month}
              setSearch={(val) => handleSearch("month", val)}
              selectedItems={filters.month}
              toggleItem={(item) => toggleItem("month", item)}
              selectAll={() => selectAll("month", monthList)}
            />
            <Button
              onClick={applyFilters}
              style={{
                width: "100%",
                // height: "44px",
                padding: "12px",
                borderRadius: "12px",
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour12,
                border: "none",
                fontWeight: "700",
              }}
              className="common-hover-btn"
            >
              Apply Filters
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Row className="g-4">
        {/* LEFT FILTER */}
        <Col xl={3} lg={4} className="d-none d-lg-block">
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <PayRollFilterBox
              title="Year"
              items={yearList}
              search={search.year}
              setSearch={(val) => handleSearch("year", val)}
              selectedItems={filters.year}
              toggleItem={(item) => toggleItem("year", item)}
              selectAll={() => selectAll("year", yearList)}
            />

            <PayRollFilterBox
              title="Month"
              items={monthList}
              search={search.month}
              setSearch={(val) => handleSearch("month", val)}
              selectedItems={filters.month}
              toggleItem={(item) => toggleItem("month", item)}
              selectAll={() => selectAll("month", monthList)}
            />
            <Button
              onClick={applyFilters}
              style={{
                width: "100%",
                // height: "44px",
                padding: "12px",
                borderRadius: "12px",
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour12,
                border: "none",
                fontWeight: "700",
              }}
              className="common-hover-btn"
            >
              Apply Filters
            </Button>
          </div>
        </Col>

        {/* RIGHT TABLE */}
        <Col xl={9} lg={8}>
          <div
            style={{
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
            }}
          >
            <div
              style={{
                padding: "14px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color: "#fff",
                fontWeight: "600",
                fontSize: "18px",
                margin: 0,
                letterSpacing: "1px",
              }}
            >
              SALARY SUMMARY
            </div>

            <PayRollTable
              columns={getColumns}
              data={getRows}
              showSearch={true}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};
